import { render, staticRenderFns } from "./Vendas.vue?vue&type=template&id=1d9624f8&scoped=true&"
import script from "./vendas.js?vue&type=script&lang=js&"
export * from "./vendas.js?vue&type=script&lang=js&"
import style0 from "./Vendas.vue?vue&type=style&index=0&id=1d9624f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9624f8",
  null
  
)

component.options.__file = "Vendas.vue"
export default component.exports